module.exports = __webpack_public_path__ + "img/bg.004532c6.jpg";